import React from 'react';
import ContactForm from '../ContactFrom/ContactForm'
import ContactMap from './ContactMap';


const Contactpage = () => {

    return (
        <div>
            
            <section className="wpo-contact-pg-section section-padding pt-0">
                <div className="container">
                    <div className="row mt-5">
                        <div className="col-lg-8">
                            <div className="wpo-contact-form-area mt-5">
                                <div className="wpo-contact-title">
                                    <h2>Have Any Question?</h2>
                                    <p>Reach Out for More Information</p>
                                </div>
                                <ContactForm />
                            </div>
                        </div>
                        <div className="col col-lg-4">
                            <div className="office-info mt-5">
                                <div className="office-info-item">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-phone-call"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Call Us:</h2>
                                        <p>+91 75650 34859</p>
                                    </div>
                                </div>
                                <div className="office-info-item">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-email-3"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>E-mail Us:</h2>
                                        <p>snbsindustries@gmail.com</p>
                                    </div>
                                </div>
                                <div className="office-info-item">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-clock"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Opening Hours:</h2>
                                        <p>10:00 AM to 06:00 PM</p>
                                    </div>
                                </div>
                                <div className="office-info-item">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-location-1"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Our Location 1:</h2>
                                        <p>Regd. Office: Flat No. 1, Mahalaxmi Residency, Bhigwan Road, Baramati, Dist-Pune, (M.S.) PIN-413102.</p>
                                    </div>
                                </div>
                                   <div className="office-info-item">
                                    <div className="office-info-icon">
                                        <div className="icon">
                                            <i className="fi flaticon-location-1"></i>
                                        </div>
                                    </div>
                                    <div className="office-info-text">
                                        <h2>Our Location 2:</h2>
                                        <p>Factory Address: Gat No.372/9/372/10/1 and 2, Village-Vanjarwadi, Tal-Karmala, Dist-Solapur, (M.S.) PIN-413203.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ContactMap />
        </div>
    )


}

export default Contactpage;
